import React from 'react';
import { Row, Col } from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { List, Map } from 'immutable';
import { HistoryForm } from './../../components';
import {
  getAllAudits,
  getAllUserAudits,
  getLoadingStatus,
  getAuditTypes,
  getPagination,
} from './../../selectors/Audit';
import { getUser } from './../../selectors/Authentication';
import { clearActionResponse } from './../../actions/Global';
import { getUserAudits } from './../../actions/Audit';

class History extends React.Component {
  /**
   * When page is loaded, attempts to get user audits.
   * All audits are only loaded upon application startup.
   */
  /*componentDidMount() {
    this.props.getUserAudits(this.props.user.toJS());
  }*/

  render() {
    return (
      <Row>
        <Col span={24}>
          <HistoryForm
            isLoading={this.props.isLoading}
            user={this.props.user}
            allAudits={this.props.allAudits}
            userAudits={this.props.userAudits}
            auditTypes={this.props.auditTypes}
            pagination={this.props.pagination}
          />
        </Col>
      </Row>
    );
  }
}

/**
 * Maps relevant store state to props for this component.
 * @param state to be handled
 * @returns {{isLoading, user, allAudits, userAudits, auditTypes}}
 * manipulated from the state before sent to this component.
 */
const mapStateToProps = (state) => {
  return {
    isLoading: getLoadingStatus(state),
    user: getUser(state),
    allAudits: getAllAudits(state),
    userAudits: getAllUserAudits(state),
    auditTypes: getAuditTypes(state),
    pagination: getPagination(state),
  };
};

/**
 * Maps relevant store actions to props for this component.
 * @param dispatch actions to be handled.
 * @returns {{clearActionResponse: clearActionResponse, getUserAudits: getUserAudits}}
 * are actions that are mapped to props for this component.
 */
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getUserAudits: getUserAudits,
      clearActionResponse: clearActionResponse,
    },
    dispatch
  );
};

/**
 * Proptypes validates that the state props are of expected type.
 * @type {{isLoading: shim, user: shim, allAudits: shim, userAudits: shim, clearActionResponse: shim, auditTypes: shim, getUserAudits: shim}}
 */
History.propTypes = {
  isLoading: PropTypes.bool,
  user: PropTypes.instanceOf(Map),
  allAudits: PropTypes.instanceOf(List),
  userAudits: PropTypes.instanceOf(List),
  auditTypes: PropTypes.instanceOf(List),
  clearActionResponse: PropTypes.func,
  getUserAudits: PropTypes.func,
  pagination: PropTypes.instanceOf(Object),
};

export default connect(mapStateToProps, mapDispatchToProps)(History);
